import React, { Component } from 'react';
import {
  ContentWrapper,
  LeftColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import styles from './Landing.css';
import MenuTitleLoyalty from '../Components/MenuTitleLoyalty';

class Landing extends Component {
  render() {
    return (
      <PageWrapper>
        <div className={`row ${styles['menu-title-loyalty-row']}`}>
          <MenuTitleLoyalty
            menuTitle="Loyalty Program"
            loyaltySubscription={this.props.loyaltySubscription}
            goToSubscribeView={this.props.goToSubscribeView}
          />
          <div className={`col-md-4`}>
            <div className="pull-right">
              <button
                className="btn btn-primary"
                onClick={this._onClickCreateLoyaltyProgram}
              >
                Create Program
              </button>
            </div>
          </div>
        </div>
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={false}>
            <NoDataAndLoading
              showLoadingSpinner={false}
              noDataToDisplay
              title="No Loyalty Program yet"
              description=""
              linkLabel="Create a Loyalty Program"
              linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/115003686774-Cara-Membuat-Loyalty-Program-"
              image={require('assets/images/trophy-heart.png')}
            />
          </LeftColumnWrapper>
        </ContentWrapper>
      </PageWrapper>
    );
  }

  _onClickCreateLoyaltyProgram = () => {
    this.props.goToCreateView();
  };
}

export default Landing;
